/* Zucchero — blog post (sections/zc-article.liquid). Options are read from data attributes set by block settings. */
(function () {
  var root = document.querySelector('[data-zca]');
  if (!root) return;
  var prose = root.querySelector('[data-zca-prose]');
  var hasFaqBlock = !!root.querySelector('[data-zca-faq]');

  /* 1. When the FAQ block is filled, an FAQ written inside the article text (its heading and everything up to the next H2) is hidden. */
  if (prose && hasFaqBlock) {
    prose.querySelectorAll('h2').forEach(function (h) {
      if (!/\b(faq|frequently asked)/i.test(h.textContent)) return;
      var n = h.nextElementSibling;
      h.hidden = true;
      while (n && n.tagName !== 'H2') { var next = n.nextElementSibling; n.hidden = true; n = next; }
    });
  }

  /* 2. Tables scroll horizontally on phones. */
  if (prose) prose.querySelectorAll('table').forEach(function (t) {
    if (t.parentElement.classList.contains('zca-table')) return;
    var w = document.createElement('div'); w.className = 'zca-table';
    t.parentNode.insertBefore(w, t); w.appendChild(t);
  });

  /* 3. A link alone in its paragraph with an arrow becomes a button (block setting). */
  if (prose && prose.getAttribute('data-btn-links') === 'true') prose.querySelectorAll('a').forEach(function (a) {
    var txt = a.textContent.trim();
    var p = a.parentElement; if (p && p.tagName === 'STRONG') p = p.parentElement;
    if (txt.indexOf('→') > -1 && txt.length < 110 && p && p.tagName === 'P' && p.textContent.trim() === txt) a.classList.add('zca-btn-link');
  });

  /* 4. Table of contents from visible H2s (plus the FAQ block). */
  var heads = prose ? Array.prototype.filter.call(prose.querySelectorAll('h2'), function (h) { return !h.hidden && h.textContent.trim(); }) : [];
  var faqH = root.querySelector('[data-zca-faq] h2');
  var items = heads.slice();
  if (faqH) items.push(faqH);
  var tocMin = prose ? parseInt(prose.getAttribute('data-toc-min') || '3', 10) : 3;
  if (items.length >= tocMin && root.querySelector('[data-zca-toc-list]')) {
    var used = {};
    items.forEach(function (h, i) {
      if (!h.id) {
        var base = h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || ('section-' + i);
        var id = base, k = 2; while (used[id] || document.getElementById(id)) { id = base + '-' + k++; }
        h.id = id;
      }
      used[h.id] = true;
    });
    root.querySelectorAll('[data-zca-toc-list]').forEach(function (ol) {
      items.forEach(function (h) {
        var li = document.createElement('li'); var a = document.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent.trim(); a.setAttribute('data-target', h.id);
        li.appendChild(a); ol.appendChild(li);
      });
      ol.closest('.zca-toc').hidden = false;
    });
    root.querySelectorAll('.zca-toc--inline a').forEach(function (a) {
      a.addEventListener('click', function () { var d = a.closest('details'); if (d) d.open = false; });
    });
    if ('IntersectionObserver' in window) {
      var links = root.querySelectorAll('.zca-toc--side a');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-target') === e.target.id); });
        });
      }, { rootMargin: '0px 0px -70% 0px' });
      items.forEach(function (h) { io.observe(h); });
    }
  } else {
    var lay = root.querySelector('.zca-layout'); if (lay) lay.classList.remove('zca-layout--toc');
  }

  /* 5. Reading progress. */
  var bar = document.querySelector('.zca-progress span');
  if (bar && prose) {
    var tick = false;
    var update = function () {
      var r = prose.getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.6;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      bar.style.transform = 'scaleX(' + p + ')'; tick = false;
    };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* 6. Reveal blocks on scroll. */
  var rev = root.querySelectorAll('.zca-reveal');
  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); ro.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    rev.forEach(function (el) { ro.observe(el); });
  } else { rev.forEach(function (el) { el.classList.add('is-in'); }); }
})();
